import React from "react";
import Section1 from "../portfolio/Section1";
import Section2 from "../portfolio/Section2";
import Section3 from "../portfolio/Section3";
import Hero1 from "../portfolio/Hero1";

const PortfolioPage = () => {
  return (
    <div>
      <Hero1 />
      <Section1 />
      <Section2 />
      <Section3 />
    </div>
  );
};

export default PortfolioPage;
